/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Col, Collapse, Row } from "react-bootstrap";
import CardC from "../../../components/CustomCard/CardC";
import { useEffect, useState } from "react";
import { Usuario } from "../../../types/admin-usuarios/Usuario";
import { Perfil } from "../../../types/admin-usuarios/Perfil";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Divider, Loader, toaster } from "rsuite";
import InputSearch from "../../../components/inputs/InputSelectSearch";
import Datatable from "../../../components/Datatable/Datatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import * as Yup from "yup";
import { useFormik } from "formik";
import createURL from "../../../libs/peticiones/url";
import Alert from "../../../components/notification/Alert";
import { System } from "../../../types/admin-usuarios/System";
import { checkPermission } from "../../../libs/menuPermissions/permissions";
import { useStore } from "../../../context/AppContext";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export default function UsuarioPerfiles() {
    const [loading, setLoading] = useState<boolean>(true);
    const [usuario, setUsuario] = useState<Usuario[]>([]);
    const [systems, setSystems] = useState<System[]>([]);

    const [selectedUsuario, setSelectedUsuario] = useState<string | undefined>();
    const [selectedSystem, setSelectedSystem] = useState<string | undefined>();

    const [perfiles, setPerfiles] = useState<any>({});

    const [usuarioPerfiles, setUsuarioPerfiles] = useState<Perfil[]>([]); // tabla
    const [cleanPerfiles, setCleanPerfiles] = useState<Perfil[]>([]); // Combo

    const [open, setOpen] = useState<boolean>(false);

    const [refresh, setRefresh] = useState<boolean>(false);

    const { state } = useStore();

    useEffect(() => {
        initialRequest();
    }, []);

    async function initialRequest(){
        await Promise.all([
            getUsuarios(),
            getSystems()
        ]);
        setLoading(false);
    }

    async function getUsuarios() {
        const res = await peticionBack({},`/usuarios`, "GET", false, toaster);
        if (res) setUsuario(res.data);
    }

    async function getSystems() {
        const res = await peticionBack({}, `/sistemas`, "GET", false, toaster);
        if (res) setSystems(res.data);
    }


    async function getPerfilesUsuario() {
        setLoading(true);
        const perfilesSistema = await getPerfilesSistema();
        if(!perfilesSistema){
            toaster.push( 
                Alert({ type: "warning", message: "El sistema no tiene perfiles asignados" }),
                { placement: "topEnd" }
            );
            setLoading(false);
            return;
        }
        const res = await peticionBack({}, `/perfiles/get_profiles/${selectedUsuario}`, "GET", false, toaster);
        if (res) {
            const filteredPA = res.filter((p: Perfil) => p.system === selectedSystem as string);
            const filteredPAIds = filteredPA.map((p: Perfil) => p._id);
            setUsuarioPerfiles(filteredPA);
            setCleanPerfiles(perfilesSistema.filter((ps: Perfil)=> !filteredPAIds.includes(ps._id) ));    
            setRefresh(true);
            setOpen(true);
        }
        setLoading(false);
    }

    async function getPerfilesSistema(): Promise<Perfil[]|null>{
        if(perfiles[selectedSystem as string]) return perfiles[selectedSystem as string];
        const url = createURL("/perfiles", [{ name: "system", value: selectedSystem as string }]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        if (res && res.data.length > 0) {
            const cpyPerfiles = { ...perfiles };
            cpyPerfiles[selectedSystem as string] = res.data;
            setPerfiles(cpyPerfiles);
            return res.data;
        }
        return null;
    }

    useEffect(() => {
        setOpen(false);
    }, [selectedUsuario, selectedSystem]);

    /* TABLA */
    const columns = [
        { data: "name" },
        {
            data: null,
            render: (row: any) => (
                <div className="d-flex justify-content-evenly">
                    {checkPermission(state, "delete") && <FontAwesomeIcon
                        icon={faTrashCan as IconProp}
                        className="text-danger cursor-pointer"
                        onClick={() =>
                            swalAction(
                                deleteRow,
                                "Remover Perfil",
                                `¿Desea remover el perfil ${row.name} al usuario?`,
                                "question",
                                row._id,
                                "Eliminar"
                            )
                        }
                    />}
                </div>
            ),
        },
    ];

    const columnDefs = [ { orderable: false, targets: [1] },
{className: "text-center", targets: [0]}];

    async function deleteRow(a: string) {
        setLoading(true);
        const params = { profile: a };
        const res = await peticionBack(params, `/usuarios/remove_profile/${selectedUsuario}`, "PUT", true, toaster);
        if (res) getPerfilesUsuario();
        setLoading(false);
    }

    return (
        <CardC>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4 className="">Perfiles de Usuarios</h4>
            </div>
            <Row>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Usuario"
                        name="usuario"
                        value={selectedUsuario as string}
                        values={usuario}
                        labelVal="fullname"
                        valueVal="_id"
                        onChangeMethod={({ target }: any) => setSelectedUsuario(target.value)}
                    />
                </Col>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Sistema"
                        name="sistema"
                        value={selectedSystem as string}
                        values={systems}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={({ target }: any) => setSelectedSystem(target.value)}
                        disabled={!selectedUsuario}
                    />
                </Col>
                <Col xs={12} className="pt-2 d-grid d-md-block text-center">
                    <Button onClick={()=>getPerfilesUsuario()}>Abrir</Button>
                </Col>
            </Row>
            <Divider />
            <Collapse in={open} onExited={() => setUsuarioPerfiles([])}>
                <div>
                    <div className="text-end">
                        <Button variant="danger" onClick={()=>setOpen(false)}>
                            Cerrar
                        </Button>
                    </div>
                    <MiniForm
                        selected={selectedUsuario}
                        perfiles={cleanPerfiles}
                        setLoading={setLoading}
                        getPerfilesAgente={getPerfilesUsuario}
                        open={open}
                        usuarios={usuario}
                        state={state}
                    />
                    { checkPermission(state, "read") &&
                    <Datatable
                        columns={columns}
                        headers={["Perfil", "Eliminar"]}
                        columnDefs={columnDefs}
                        data={usuarioPerfiles}
                        control="front"
                        stateRefresh={[refresh, setRefresh]}
                        className="p-0"
                    />}
                </div>
            </Collapse>
            {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
        </CardC>
    );
}

function MiniForm({
    selected,
    perfiles,
    setLoading,
    getPerfilesAgente,
    open,
    usuarios,
    state
}: {
    selected?: string;
    perfiles: Perfil[];
    setLoading: any;
    getPerfilesAgente: Function;
    open: boolean;
    usuarios: any[];
    state: any;
}) {
    const formSchema = Yup.object().shape({
        profile: Yup.string().required("Seleccione un perfil"),
    });

    const { handleSubmit, handleReset, setFieldValue, values, errors, touched } =
        useFormik({
            initialValues: { profile: "" },
            validationSchema: formSchema,
            onSubmit: (values) => {
                swalAction(
                    save,
                    "Agregar Perfil",
                    `¿Desea asignar este perfil a este usuario?`,
                    "question"
                );
            },
            onReset: () => { },
        });

    async function save() {
        setLoading(true);
        const res = await peticionBack(values, `/usuarios/add_profile/${usuarios.find((agente) => agente._id === selected)._id}`, "PUT", true, toaster);
        setLoading(false);
        if (res) {
            handleReset(null);
            getPerfilesAgente();
        }
    }

    useEffect(() => {
        if (!open) handleReset(null);
    }, [open]);

    return (
        <form onSubmit={handleSubmit} onReset={handleReset}>
            <Row>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Perfil"
                        name="profile"
                        value={values.profile}
                        error={errors.profile}
                        touched={touched.profile}
                        values={perfiles}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={({ target }: any) =>
                            setFieldValue("profile", target.value)
                        }
                    />
                </Col>
                <Col
                    xs={12}
                    md="auto"
                    className="align-self-center pt-md-2 d-grid d-md-block"
                >{checkPermission(state, "create") &&(
                    <Button variant="success" type="submit">
                        Guardar
                    </Button>
                    )}
                </Col>
            </Row>
        </form>
    );
}
